var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{nativeOn:{"click":function($event){return _vm.joinUs.apply(null, arguments)}}},[_c('mars-image',{staticClass:"join-card",attrs:{"id":"join","src":"https://lvlin-base.cdn.bcebos.com/law/pages/select/card.png","mode":"widthFix","preview":false,"data-area":_vm.fr + '_show',"data-serverid":"16318","data-exts":JSON.stringify({
    fr: _vm.fr,
}),"data-extswan":{
    fr: _vm.fr,
}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }